

const Coins = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.1528 13.7825C59.8872 12.8606 60.3247 11.6731 60.3247 10.4075C60.3247 7.40747 57.8872 4.95435 54.8872 4.95435C53.606 4.95435 52.4341 5.39185 51.5122 6.12622C46.1997 2.34497 39.7935 0.219971 32.7778 0.219971C14.8247 0.219971 0.168457 14.6731 0.168457 32.6575C0.168457 50.6418 14.8091 65.22 32.7622 65.22C50.7153 65.22 65.1685 50.6418 65.1685 32.6575C65.1685 25.6262 62.9341 19.1106 59.1528 13.7825ZM54.8559 6.98557C56.7622 6.98557 58.2934 8.53245 58.2934 10.4231C58.2934 12.3293 56.7466 13.8606 54.8559 13.8606C52.9497 13.8606 51.4184 12.3137 51.4184 10.4231C51.4184 8.53245 52.9497 6.98557 54.8559 6.98557ZM53.8872 53.9231C51.1372 56.6731 47.9184 58.8606 44.3403 60.3762C40.6372 61.9387 36.8091 62.7512 32.7466 62.7512C28.6997 62.7512 24.6684 61.9543 20.9653 60.3762C17.3872 58.8606 14.1841 56.7043 11.4184 53.9231C8.66844 51.1731 6.49656 47.9387 4.98094 44.3606C3.41844 40.6575 2.62156 36.72 2.62156 32.6575C2.62156 28.6106 3.41844 24.6575 4.98094 20.9543C6.49656 17.3762 8.65281 14.1575 11.4184 11.3918C14.1841 8.62621 17.3872 6.45434 20.9653 4.93871C24.6684 3.37622 28.6841 2.73559 32.7466 2.73559C36.7934 2.73559 40.6372 3.36059 44.3403 4.93871C46.3247 5.78246 48.1997 6.82934 49.9497 8.06371C49.6216 8.76684 49.4341 9.54809 49.4341 10.3918C49.4341 13.3918 51.8716 15.845 54.8716 15.845C55.6997 15.845 56.4809 15.6575 57.1997 15.3293C58.4341 17.0793 59.4809 18.9543 60.3247 20.9543C61.8872 24.6575 62.6841 28.595 62.6841 32.6575C62.6841 36.7043 61.8872 40.6575 60.3247 44.3606C58.8091 47.9387 56.6528 51.1575 53.8872 53.9231Z"
        fill="#4CAF50"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7467 17.7356C24.4655 17.7356 17.7467 24.4231 17.7467 32.72C17.7467 41.0168 24.4498 47.7356 32.7467 47.7356C41.028 47.7356 47.7467 41.0168 47.7467 32.72C47.7467 24.4231 41.028 17.7356 32.7467 17.7356ZM32.7467 45.1887C25.856 45.1887 20.2935 39.5949 20.2935 32.7199C20.2935 25.8293 25.856 20.2824 32.7467 20.2824C39.6373 20.2824 45.1998 25.8449 45.1998 32.7199C45.1998 39.6105 39.6217 45.1887 32.7467 45.1887Z"
        fill="#4CAF50"
      />
    </svg>
  );
};

export default Coins;
